import { Box, Grid } from '@mui/material'
import React, { FC } from 'react'

import { IsServiceItem } from '../interfaces/IsServiceItem'
import ServiceItem from './ServiceItem'

interface Props {
  items: IsServiceItem[]
}

const ServiceItemContainer: FC<Props> = ({ items }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'hidden',
        overflowY: 'auto',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        maxHeight: '480px',
        my: 1,
        marginBottom: 0,
      }}
    >
      {items.map((item) => (
        <ServiceItem icon={item.icon} key={item.id} onClick={item.onClick} title={item.title} />
      ))}
    </Box>
  )
}

export default ServiceItemContainer
